import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader, Card, StatusPill } from '@/components/Primitives';
import { Trash, Check } from '@phosphor-icons/react';

const Voicemail = () => {
    const [items, setItems] = useState([]);

    const load = async () => {
        const r = await api.get('/voicemail');
        setItems(r.data);
    };
    useEffect(() => { load(); }, []);

    const markRead = async (id) => {
        await api.post(`/voicemail/${id}/mark-read`);
        load();
    };
    const del = async (id) => {
        if (!window.confirm('Smazat zprávu?')) return;
        await api.delete(`/voicemail/${id}`); load();
    };

    return (
        <>
            <PageHeader
                eyebrow="Messages"
                title="Voicemail"
                description="Hlasové zprávy z příchozích hovorů. Můžete přehrát, stáhnout, smazat nebo označit jako přečtené."
            />
            <Card>
                {items.length === 0 ? (
                    <div className="py-8 text-center text-sm font-mono" style={{ color: 'var(--text-secondary)' }}>
                        Žádné hlasové zprávy.
                    </div>
                ) : (
                    <div className="space-y-2">
                        {items.map((v) => (
                            <div key={v.id} className="flex items-center gap-3 px-3 py-2 border"
                                 style={{ borderColor: 'var(--border-default)', borderRadius: 2 }}>
                                <div className="min-w-0 flex-1">
                                    <div className="text-sm">
                                        <span className="font-mono">{v.caller_id || '—'}</span> →{' '}
                                        <span className="font-mono">{v.did_number || '—'}</span>
                                    </div>
                                    <div className="text-[11px] font-mono"
                                         style={{ color: 'var(--text-secondary)' }}>
                                        {(v.created_at || '').replace('T', ' ').slice(0, 19)} · {v.duration_seconds}s
                                    </div>
                                </div>
                                {v.audio_url && (
                                    <audio src={v.audio_url} controls className="h-8" />
                                )}
                                <StatusPill status={v.is_read ? 'neutral' : 'info'}
                                            label={v.is_read ? 'přečteno' : 'nové'} />
                                <button onClick={() => markRead(v.id)} className="p-1 hover:bg-[var(--bg-surface-hover)]"
                                        title="Označit jako přečtené" data-testid={`vm-read-${v.id}`}>
                                    <Check size={14} />
                                </button>
                                <button onClick={() => del(v.id)} className="p-1 hover:bg-[var(--bg-surface-hover)]"
                                        data-testid={`vm-delete-${v.id}`}>
                                    <Trash size={14} />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </Card>
        </>
    );
};

export default Voicemail;
